import * as React from 'react';
import PageTitle from '../PageTitle';
import PageBody from '../PageBody';
import styles from './FeatureUnavailable.module.scss';

interface FeatureUnavailableProps {
  /** Page heading — mirrors the feature's normal title. */
  title: string;
  /** Optional override for the body copy. */
  message?: string;
}

const DEFAULT_MESSAGE =
  'Get in touch with us to upgrade your account for this feature.';

/**
 * Read-only placeholder shown when a rollout feature's backend API is not
 * available yet (404 / disabled). Keeps the surface visible and reassuring
 * rather than erroring out. See `useFeatureAvailability`.
 */
export const FeatureUnavailable: React.FC<FeatureUnavailableProps> = ({ title, message }) => (
  <div className={styles.pageWrapper}>
    <PageTitle title={title} className={styles.pageTitle} />
    <PageBody>
      <div className={styles.card} data-test="feature-unavailable">
        <div className={styles.badge}>Not enabled</div>
        <p className={styles.message}>{message ?? DEFAULT_MESSAGE}</p>
      </div>
    </PageBody>
  </div>
);

export default FeatureUnavailable;
